var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Connect_Sessions"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Connect_Sessions",
    clipPath: "url(#clip-Connect_Sessions)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Connect_Tab",
    "data-name": "Connect Tab",
    transform: "translate(-158.524 -445.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M1.993,11.618h0l-.109-.112A6.864,6.864,0,0,1,0,6.739,7.174,7.174,0,0,1,.088,5.616h1.09a5.887,5.887,0,0,0-.107,1.123A5.726,5.726,0,0,0,2.6,10.67a2.68,2.68,0,0,0-.612.947Zm9.224-.384h0a3.161,3.161,0,0,0-.728-.837,5.775,5.775,0,0,0,1.294-3.657,5.948,5.948,0,0,0-.106-1.123h1.089a7.148,7.148,0,0,1,.089,1.123,6.906,6.906,0,0,1-1.637,4.494ZM8.472,1.549h0A5.131,5.131,0,0,0,4.823,1.38,2.813,2.813,0,0,0,4.08.461,6.186,6.186,0,0,1,9.116.616a2.767,2.767,0,0,0-.644.932Z",
    transform: "translate(166.785 454.341)",
    fill: "#fcf8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-users",
    "data-name": "Icon feather-users",
    transform: "translate(169.277 461.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M1.5,25.87V24.747c0-1.241,1.554-2.247,2.653-2.247H6.806c1.1,0,2.653,1.006,2.653,2.247V25.87",
    transform: "translate(-1.5 -16.787)",
    fill: "none",
    stroke: "#fcf8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M7.5,6.185A1.685,1.685,0,1,0,9.185,4.5,1.685,1.685,0,0,0,7.5,6.185Z",
    transform: "translate(-5.415 -4.5)",
    fill: "none",
    stroke: "#fcf8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-users-2",
    "data-name": "Icon feather-users",
    transform: "translate(163.696 450.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3813-2",
    "data-name": "Path 3813",
    d: "M1.5,25.8V24.7a2.45,2.45,0,0,1,2.247-2.2H5.993A2.45,2.45,0,0,1,8.24,24.7v1.1",
    transform: "translate(11.434 -16.993)",
    fill: "none",
    stroke: "#fcf8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M1.5,25.8V24.7a2.45,2.45,0,0,1,2.247-2.2H5.993A2.45,2.45,0,0,1,8.24,24.7v1.1",
    transform: "translate(-1.671 -16.792)",
    fill: "none",
    stroke: "#fcf8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814-2",
    "data-name": "Path 3814",
    d: "M7.5,6.185A1.685,1.685,0,1,0,9.185,4.5,1.685,1.685,0,0,0,7.5,6.185Z",
    transform: "translate(7.264 -4.5)",
    fill: "none",
    stroke: "#fcf8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M7.5,6.185A1.685,1.685,0,1,0,9.185,4.5,1.685,1.685,0,0,0,7.5,6.185Z",
    transform: "translate(-5.842 -4.5)",
    fill: "none",
    stroke: "#fcf8f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectSessions);
export default __webpack_public_path__ + "static/media/Connect_Sessions.b03cce16f5cc19ca113241a472503ef4.svg";
export { ForwardRef as ReactComponent };